module.exports = "<div class=\"container justify-content-center pl-5 pr-5 mt-5\">\r\n  <h3 class=\"headlines\">Vælg den BroBizz du vil bruge</h3>\r\n</div>\r\n"